<template>
  <div>
    <div class="section-head">签到档位奖励设置</div>
    <el-table :data="props.tiers" border size="mini" class="tier-table sign-in-tier-table">
      <el-table-column label="日期" width="90" align="center">
        <template slot-scope="scope">第{{ scope.row.day_index }}天</template>
      </el-table-column>

      <el-table-column label="奖励类型" min-width="420">
        <template slot-scope="scope">
          <div class="tier-reward-cell">
            <el-select
              v-model="scope.row.reward_type"
              placeholder="选择奖励类型"
              size="mini"
              style="width: 140px"
              @change="onRewardTypeChange(scope.$index)"
            >
              <el-option label="无奖励" :value="SIGN_IN_REWARD_TYPE_NONE" />
              <el-option label="金币" :value="SIGN_IN_REWARD_TYPE_COIN" />
            </el-select>

            <template v-if="scope.row.reward_type === SIGN_IN_REWARD_TYPE_COIN">
              <el-select
                v-model="scope.row.reward_mode"
                placeholder="奖励方式"
                size="mini"
                style="width: 130px"
                @change="onRewardModeChange(scope.$index)"
              >
                <el-option label="固定奖励" :value="REWARD_MODE_FIXED" />
                <el-option label="随机奖励" :value="REWARD_MODE_RANDOM" />
              </el-select>

              <template v-if="scope.row.reward_mode === REWARD_MODE_FIXED">
                <span class="currency-prefix"></span>
                <el-input-number
                  style="width: 120px"
                  v-model="scope.row.gold"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="mini"
                />
              </template>

              <template v-else>
                <span class="currency-prefix"></span>
                <el-input-number
                  style="width: 90px"
                  v-model="scope.row.gold_min"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="mini"
                />
                <span class="rule-suffix">~</span>
                <el-input-number
                  style="width: 90px"
                  v-model="scope.row.gold_max"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="mini"
                />
              </template>
            </template>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="奖励稽核倍数" width="140" align="center">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.multiple"
            :min="0"
            :precision="2"
            :controls="false"
            size="mini"
            :disabled="scope.row.reward_type !== SIGN_IN_REWARD_TYPE_COIN"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column label="已发放（份数）" width="170" align="center">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.settled_count"
            :min="0"
            :precision="0"
            :controls="false"
            size="mini"
            disabled
            style="width: 100%"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
const SIGN_IN_REWARD_TYPE_COIN = 1
const SIGN_IN_REWARD_TYPE_NONE = -1

const REWARD_MODE_FIXED = 1
const REWARD_MODE_RANDOM = 2

const props = defineProps({
  tiers: {
    type: Array,
    required: true,
  },
})
/* eslint-enable no-undef */

function onRewardTypeChange(index) {
  const row = props.tiers[index]
  if (!row) return
  if (row.reward_type === SIGN_IN_REWARD_TYPE_NONE) {
    row.reward_mode = REWARD_MODE_FIXED
    row.gold = undefined
    row.gold_min = undefined
    row.gold_max = undefined
    row.multiple = 0
  } else {
    if (row.reward_mode == null) row.reward_mode = REWARD_MODE_FIXED
    if (row.multiple == null || row.multiple === 0) row.multiple = 1
  }
}

function onRewardModeChange(index) {
  const row = props.tiers[index]
  if (!row) return
  if (row.reward_type !== SIGN_IN_REWARD_TYPE_COIN) return

  if (row.reward_mode === REWARD_MODE_FIXED) {
    row.gold_min = undefined
    row.gold_max = undefined
    if (row.gold == null) row.gold = 0
  } else {
    row.gold = undefined
    if (row.gold_min == null) row.gold_min = 0
    if (row.gold_max == null) row.gold_max = 0
  }
}
</script>

<style lang="scss" scoped>
.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.tier-table {
  width: 100%;
  margin-bottom: 8px;
}

.tier-reward-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.currency-prefix {
  color: #606266;
  font-size: 13px;
}

.rule-suffix {
  color: #606266;
  font-size: 13px;
  margin: 0 2px;
}
</style>
